<template>
  <svg
    width="10"
    height="13"
    viewBox="0 0 10 13"
  >
    <path d="M4.83562 0.505318L5 0.5C6.32548 0.5 7.41004 1.53154 7.49468 2.83562L7.5 3V4H8.5C9.32843 4 10 4.67157 10 5.5V11.5C10 12.3284 9.32843 13 8.5 13H1.5C0.671573 13 0 12.3284 0 11.5V5.5C0 4.67157 0.671573 4 1.5 4H2.5V3C2.5 1.67452 3.53154 0.589961 4.83562 0.505318ZM8.5 5H1.5C1.22386 5 1 5.22386 1 5.5V11.5C1 11.7761 1.22386 12 1.5 12H8.5C8.77614 12 9 11.7761 9 11.5V5.5C9 5.22386 8.77614 5 8.5 5ZM5 7.5C5.55228 7.5 6 7.94772 6 8.5C6 9.05228 5.55228 9.5 5 9.5C4.44772 9.5 4 9.05228 4 8.5C4 7.94772 4.44772 7.5 5 7.5ZM5.14446 1.50687L5 1.5C4.2203 1.5 3.57955 2.09489 3.50687 2.85554L3.5 3V4H6.5V3C6.5 2.2203 5.90511 1.57955 5.14446 1.50687Z" />
  </svg>
</template>
